module.exports = __webpack_public_path__ + "fonts/fa-solid-900.4628063.woff2";